import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { IMAGES } from '~/assets/assetsPath';
import styles from './IntroductionSpa.module.scss';

const cx = classNames.bind(styles);

function IntroductionSpa() {
    return (
        <div className={cx('wrapper')}>
            <div className={cx('top-wrapper')}>
                <Row>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <div className={cx('text')}>
                            <p className={cx('title')}>Home spa</p>
                            <p className={cx('content-1')}>
                                At Beauty-ms, we choose precious herbs and techniques to listen and soothe the neck's body
                                Traditionally transmitted in the mysterious East to care for everyone's skin, hair, hands, etc.
                                Through the services, you will experience the journey of finding your roots
                                traditional and with great indigenous values ​​but are gradually disappearing under the impact of
                                modern life.
                            </p>
                            <p className={cx('content-2')}>
                                That is also the reason Beauty-ms creates a peaceful resting place in small spaces
                                this beautiful. From those traditional values, we hope to bring them to everyone
                                Women around the world have precious moments to love themselves and be happy
                                Be happy at any time and let pure natural beauty speak.
                            </p>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                        <div className={cx('thumbnail')}>
                            <img src={IMAGES.IntroRight} alt="intro" className={cx('intro-img')} />
                        </div>
                    </Col>
                </Row>
            </div>
            <div className={cx('bottom-wrapper')}>
                <div className={cx('bottom-background')}>
                    <img src={IMAGES.BackgroundHome} alt="" className={cx('background-main')} />
                    <img src={IMAGES.Flower1} alt="" className={cx('img-flower-1')} />
                    <img src={IMAGES.Flower2} alt="" className={cx('img-flower-2')} />
                    <img src={IMAGES.Flower3} alt="" className={cx('img-flower-3')} />
                </div>
                <div className={cx('bottom-header')}>
                    <p className={cx('bottom-title')}>Why did you choose Beauty-ms?</p>
                </div>

                <div className="container">
                    <Row>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <div className={cx('reason-image')}>
                                <img src={IMAGES.Image28} alt="" className={cx('img-28')} />
                            </div>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <div className={cx('reason')}>
                                <div className={cx('target-block')}>
                                    <img src={IMAGES.target} alt="" />
                                    <div className={cx('target-content')}>
                                        <h3>Goal </h3>
                                        <p>
                                            Beauty-ms carefully selects and trains technicians not only
                                            skills, knowledge but also friendliness and professionalism with customers.
                                            You will be completely comfortable and satisfied when relaxing at Beauty-ms.
                                        </p>
                                    </div>
                                </div>
                                <div className={cx('mission-block')}>
                                    <img src={IMAGES.mission} alt="" />
                                    <div className={cx('mission-content')}>
                                        <h3>Mission</h3>
                                        <p>
                                            With convenience criteria, coming to Beauty-ms, you do not need to travel too much
                                            Many places for beauty and relaxation. Beauty-ms always puts effort into practice
                                            The process of building and maintaining a trustworthy brand image in the eyes of customers
                                            row.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default IntroductionSpa;
